var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-block"},[_c('div',{staticClass:"code-block-header"},[_c('CncButton',{attrs:{"name":"copy code","leftIcon":{ name: 'ico_paper_2' },"size":"small","type":"ghost"},on:{"click":_vm.copyCode}})],1),_c('pre',[_c('code',{staticClass:"code-block__content",domProps:{"innerHTML":_vm._s(_vm.highlightedCode)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }